export default __webpack_public_path__ + "static/media/Insurance.8cb45a69.svg";